import classNames from 'classnames';
import React , { ReactElement, useState } from 'react';
import Link from 'next/link';
import LinesEllipsis from 'react-lines-ellipsis/lib/loose';
import { Picture, ISrcSet } from '@kursk/components/ui/Picture/Picture';
import style from './MovieCard.module.scss';
import { isTicketsInfoAvailable } from '@common/utils/tickets';
import _ from 'lodash';
import { getPriceTitle } from '@kursk/utils/getPriceTitle';
import { IMovie } from "@common/redux/types/movie";
import { ITicketsInfo } from "@common/redux/types/common";

interface IMovieCardProps {
  movie: IMovie;
  type: 'small' | 'medium';
  customStyle?: {
    readonly [key: string]: string;
  }
}

const isEipskPricesExists = (movie: IMovie) =>
  Boolean(movie.eipskPrices) && !_.isEmpty(movie.eipskPrices) &&
    (!_.isNull(movie.eipskPrices.min) || !_.isNull(movie.eipskPrices.max));

export function MovieCard({ movie, type, customStyle }: IMovieCardProps): ReactElement {
  const styles = customStyle || style;
  const [isHover, setIsHover] = useState(false);

  const imgSrcSet: ISrcSet[] = [
    {
      media: '(min-width: 0px)',
      width: type === 'small' ? 270 : 580,
      height: 241,
      cropMode: type === 'small' ? 'noCrop' : 'fromTop',
    }
  ];

  const getPriceInfo = (): string | JSX.Element => {
    const { all } = movie?.actualSeances || {};
    const { eipskPrices: { max, min } = {} } = movie;
    const availableTicketsInfos: ITicketsInfo[] = all?.map(item => item.ticketsInfo)
      .filter((ticketsInfo) => isTicketsInfoAvailable(ticketsInfo))

    const maxPrice = _(availableTicketsInfos).map('maxPrice').max();
    const minPrice = _(availableTicketsInfos).map('minPrice').min();

    if (!_.isUndefined(minPrice) && !_.isUndefined(maxPrice)) {
      return getPriceTitle(minPrice, maxPrice);
    }

    if (isEipskPricesExists(movie)) {
      return getPriceTitle(min * 100, max * 100);
    }

    return '';
  }

  return (
    <Link href={`/movies/${movie._id}/${movie.sysName}`}>
      <a>
        <div
          className={classNames(styles.wrapper, type === 'medium' && styles.mediumType)}
          onMouseOver={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          <div className={styles.badge}>Кино</div>
          <Picture className={styles.image} srcSet={imgSrcSet} image={movie.image} />
          <div className={classNames(styles.info, type === 'medium' && styles.mediumTypeInfo)}>
            <LinesEllipsis
              text={movie.name}
              maxLine={isHover ? 4 : 3}
              ellipsis='...'
              trimRight
              basedOn='letters'
              className={styles.title}
            />
            <p className={styles.price}>{getPriceInfo()}</p>
          </div>
        </div>
      </a>
    </Link>
  );
}
